import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { colors } from '../styles';

interface SectionHeadingProps {
    title: string;
    subtitle?: string;
    icon?: ReactNode;
    /** תוכן שמוצג בקצה השני של הכותרת (למשל צ'יפי סינון) */
    action?: ReactNode;
}

const SectionHeading = ({ title, subtitle, icon, action }: SectionHeadingProps) => (
    <Stack
        dir="rtl"
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        alignItems={{ xs: 'flex-start', md: 'flex-end' }}
        justifyContent="space-between"
        sx={{ mb: 2.5, textAlign: 'start' }}
    >
        <Box>
            <Stack direction="row" spacing={1} alignItems="center">
                {icon}
                <Typography variant="h2" component="h2" sx={{ fontWeight: 900, color: colors.ink }}>
                    {title}
                </Typography>
            </Stack>
            {subtitle && <Typography sx={{ color: colors.body, mt: 0.5, lineHeight: 1.7, maxWidth: 720 }}>{subtitle}</Typography>}
        </Box>
        {action}
    </Stack>
);

export default SectionHeading;
